module.exports = __webpack_public_path__ + "img/u103.0897e98.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u103.png
// module id = sjOz
// module chunks = 0